import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { proposalApi } from '@modules/proposals/api';
import queryClient from '@app/queryClient';
import { USER_EVENTS } from '@shared/analytics/events';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { UpdateProposalConfigurationRequestDTO } from '@modules/proposals/api/dto/updateProposalConfiguration.dto';

const useUpdateProposalConfiguration = (externalId: string) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['updateProposalConfig'],
    mutationFn: (body: UpdateProposalConfigurationRequestDTO) =>
      proposalApi.updateProposalConfiguration(externalId, body),
    onMutate: () => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_UPDATE_ATTEMPTED, {
        useContext: true,
        addToContext: true,
        proposal_id: externalId,
      });
    },
    onSuccess: (_) => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_UPDATE_COMPLETED, { useContext: true });
      queryClient.refetchQueries({ queryKey: ['proposal', externalId] });
      queryClient.refetchQueries({ queryKey: ['proposalPreview', externalId] });
      toast('info', { message: 'Proposal config updated' });
    },
    onError: (e) => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_UPDATE_FAILED, {
        useContext: true,
        error_message: e.message,
      });
      toast('error', { message: e.message });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useUpdateProposalConfiguration;
